import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
  editContactAction,
  addContactActionWithPagination,
  GetCountofInProgressTransactions,
  getUserRolesActionNew,
  fetchClientsWithPagination,
  deleteClientAction,
  reactivateClientAction,
  resendRegisterContactLinkAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import AddContact from "../Contacts/CreateContactNew";
import EditContact from "../Contacts/EditContactNew";
import noRecord from "./../../assets/img/no-record.png";
import NoContact from "./../../assets/img/no-contact.jpg";
import PhoneNumber from "../Common/phoneNumber";
import DataTable from "react-data-table-component";
import Logo from "./../../assets/img/logo.png";
import { toastMessage, cryptoTokenDecode } from "../Common/Common";
import * as code from "../../config/Constants";
import { TextField, IconButton } from "@material-ui/core";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  CheckCircle,
  CheckCircleOutline,
  Restore,
  Delete,
  Edit,
  Search,
  Visibility,
} from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import ReactPaginate from "react-paginate";
import UrlConstants from "../../config/UrlConstants";
import { DebounceInput } from "react-debounce-input";
import * as message from "../../config/CommonMessages";
import { getBillingPaymentDetails } from "../../actions/BillingActions";
import moment from "moment";
import { ContentPasteGo, UploadFile } from "@mui/icons-material";
import Tooltip from "@material-ui/core/Tooltip";
import ViewContact from "../Contacts/ViewContact";
import Detail from "../Contacts/Detail/Detail";
var CryptoJS = require("crypto-js");

const ClientsFilter = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search by name"
      value={filterText}
      onChange={onFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
    <Button
      type="button"
      onClick={onClear}
      variant="primary"
      className="btn-blue btn-head ml-2"
    >
      Clear
    </Button>
  </>
);

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Role",
    selector: "role",
    // sortable: true,
  },
  {
    name: "Mobile Number",
    selector: "mobileNumber",
    //sortable: true,
    width: window.innerWidth <= 1366 ? "200px" : "",
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    width: window.innerWidth <= 1366 ? "270px" : "",
  },
  {
    name: "Status",
    selector: "isDeletedVendor",
    // sortable: true,
    width: "115px",
  },
  {
    name: "",
    selector: "view",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "edit",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "delete",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "uploadDoc",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "resendRegisterLink",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
];

function Clients({
  getContactsActions,
  getUserRolesAction,
  deleteContactAction,
  reActivateDeletedContactAction,
  addContactActionWithPagination,
  GetCountofInProgressTransactions,
  getUserRolesActionNew,
  getBillingPaymentDetails,
  fetchClientsWithPagination,
  deleteClientAction,
  reactivateClientAction,
  resendRegisterContactLinkAction,
}) {
  const history = useHistory();
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [clients, setClients] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [showViewModal, setShowViewModal] = React.useState(false);
  const [showUploadDoc, setShowUploadDoc] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [userType, setUserType] = React.useState(cryptoTokenDecode().usertype);
  const [currentRole, setCurrentRole] = React.useState(
    localStorage.getItem("currentRole")
  );
  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [Rerander, setRerander] = React.useState(0);
  const [PageSize, SetPageSize] = React.useState(10);
  const [userRoles, setUserRoles] = React.useState([]);
  const [selectedRole, setSelectedRole] = React.useState("");
  const [usertype, setUsertype] = React.useState(cryptoTokenDecode().usertype);
  const [permissionarray, setPermissionarray] = React.useState([]);
  const [RollId, setRollId] = React.useState();

  React.useEffect(() => {
    setShowLoader(true);
    // getAllClients();
    //getContactsWithPagination();
    getUserRolesActionNew().then((roleList) => {
      // console.log("roleList", roleList);
      let roleObj = roleList.find((o) => o.name === "Client");
      // console.log("roleObj", roleObj);
      let roleIdVar = roleObj._id;
      setSelectedRole(roleIdVar);
      getContactsWithPagination(roleIdVar);
    });

    // this api calls only for account owner , because account owner has payment details only.
    if (localStorage.getItem("usertype") === "ACCTOWNER") {
      // getPaymentDetails();
    }

    getUserPermissions();
  }, [PageNumber, Rerander]);

  function getUserPermissions() {
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log("getUserPermissions decryptedData39", decryptedData);
        permissionarray = decryptedData.split(",");
        // console.log("getUserPermissions permissionarray", permissionarray);
        setPermissionarray(permissionarray);
      }
    }
  }

  function checkPermission(checkFor) {
    if (usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        permissionarray &&
        permissionarray.length > 0 &&
        checkFor.some((item) => permissionarray.includes(item));
      return hasSome;
    }
  }

  //this function is called for updation of invoice calculations , so when we add any contact it updates calculations.
  function getPaymentDetails() {
    const today = moment();
    let data = {
      userId: localStorage.getItem("ID"),
      invoicePeriod: today.format("YYYYMM"),
    };
    getBillingPaymentDetails(data)
      .then((res) => {})
      .catch((err) => {
        // console.log(err);
      });
  }

  function getAllClients() {
    let rolename = "admin";
    if (userType === message.VENDOR && currentRole === message.BUYERAGENT) {
      rolename = "ep";
      getContactsActions(
        rolename,
        "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
      )
        .then((res) => {
          getUserRolesAction("?id=" + localStorage.getItem("ownerId"));
          setClients(res.data);
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      getContactsActions("Client")
        .then((res) => {
          getUserRolesAction();
          setClients(res.data);
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    return clients;
  }

  const handleClear = () => {
    if (filterText) {
      setFilterText("");
      setRerander(!Rerander);
    }
  };

  const Dosearch = (SearchValue) => {
    // console.log("searchValue",SearchValue)
    setFilterText(SearchValue);
    setRerander(!Rerander);
  };

  function getContactsWithPagination(roleIdVar) {
    let formData = {
      page: PageNumber,
      searching: filterText,
      WantDeletedalso: true,
      SearchWithEmailAlso: true,
      PageSize: PageSize,
      roleFilter: roleIdVar,
      ownerID: localStorage.getItem("ownerId"),
    };
    fetchClientsWithPagination(formData)
      .then((res) => {
        // getUserRolesAction();
        // console.log("at client", res.status);
        if (res.status == 200) {
          setClients(res.data.data);
          setnumberOfPages(res.data.total);
          setShowLoader(false);
          if (res.data && res.data.data.length > 0) {
            setRollId(res.data.data[0].roles[0]);
          }
        } else {
          setClients([]);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    return clients;
  }

  const handlePageClick = (event) => {
    // console.log("1", event.selected);
    setPageNumber(event.selected);
  };

  const handleChange = (event) => {
    SetPageSize(event.target.value);
    setRerander(!Rerander);
  };

  function checkTransaction(id) {
    setShowLoader(true);
    // console.log("at delete client at New",id)
    GetCountofInProgressTransactions(id, "Client")
      .then((res) => {
        if (res.status == 200) {
          setShowLoader(false);
          if (res.data.total > 0) {
            confirmAlert({
              // title: 'Delete Client',
              // message: 'This Client has InProgress Artworks. Do you want to delete this Client?',
              // buttons: [
              //   {
              //     label: 'Yes Delete it !',
              //     onClick: () => deleteClient(id)
              //   },
              //   {
              //     label: 'No',
              //     onClick: () => {}
              //   }
              // ]
              customUI: ({ onClose }) => {
                return (
                  <div
                    className="
							 "
                  >
                    <div className="react-confirm-alert-body">
                      <h2>Deactivate Client</h2>
                      <p>This Client has InProgress Artworks. </p>
                      <p>Do you want to deactivate this Client? </p>
                      <div className="react-confirm-alert-button-group">
                        <button
                          onClick={() => {
                            deleteClient(id);
                            onClose();
                          }}
                        >
                          {" "}
                          Yes, deactivate it!{" "}
                        </button>
                        <button onClick={onClose}>No</button>
                      </div>
                    </div>
                  </div>
                );
              },
            });
          } else {
            deleteClient(id);
          }
        } else {
          toastMessage(code.ERROR);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function deleteClient(id) {
    // console.log("======at delete ===id",id)
    setShowLoader(true);
    // console.log("at delete client at New",id)
    deleteClientAction(id)
      .then((res) => {
        // getAllClients();
        setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function showAddClientModal() {
    setShowAddModal(true);
    // console.log("url", UrlConstants.SiteUrl + "clients");
  }

  function closeAddModal() {
    setShowAddModal(false);
    // getAllClients();
    if (filterText) {
      setFilterText("");
      setRerander(!Rerander);
    } else {
      setRerander(!Rerander);
    }
  }

  function editClient(contact) {
    setShowEditModal(true);
    contact.roles = "Client";
    setContactData(contact);
  }

  function closeEditModal() {
    setShowEditModal(false);
    setRerander(!Rerander);
    // getAllClients();
  }

  function viewContact(contact) {
    setContactData(contact);
    setShowViewModal(true);
  }

  function closeViewModal() {
    setShowViewModal(false);
    setShowUploadDoc(false);
    // setRerander(!Rerander);
  }

  function contactUploadDoc(contact) {
    setContactData(contact);
    setShowUploadDoc(true);
  }

  function reActivateUser(userId) {
    setShowLoader(true);
    reactivateClientAction(userId)
      .then((response) => {
        setRerander(!Rerander);
        // getAllClients();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function resendRegisterContactLink(contact) {
    let data = {
      id: contact.contactId,
    };
    setShowLoader(true);
    resendRegisterContactLinkAction(data)
      .then((res) => {
        setShowLoader(false);
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, res.data);
        } else {
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let rows = [];
  for (var i = 0; i < clients.length; i++) {
    let client = clients[i];

    let contactData = {
      id: client._id,
      firstname:
        client.UserData[0].firstname +
        (client.UserData[0].lastname ? " " + client.UserData[0].lastname : ""),
      role: "Client",
      mobileNumber: (
        <PhoneNumber phoneNumber={client.UserData[0].mobileNumber} />
      ),
      email:
        client.UserData[0].email && client.UserData[0].email.address
          ? client.UserData[0].email.address
          : "",
      isDeletedVendor:
        client.isDeleted === false ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
      delete: checkPermission([message.manage_client]) ? (
        client.isDeleted === false ? (
          <IconButton
            onClick={() =>
              checkTransaction(client._id) && !client.isDeleted === true
            }
          >
            <Tooltip title="Deactivate">
              <Delete />
            </Tooltip>
          </IconButton>
        ) : (
          <IconButton
            onClick={() => reActivateUser(client._id) && !client.isDeleted}
          >
            <Tooltip title="Reactivate">
              <Restore />
            </Tooltip>
          </IconButton>
        )
      ) : (
        ""
      ),
      view: checkPermission([message.manage_client, message.view_client]) ? (
        client.isDeleted === false ? (
          <IconButton onClick={() => viewContact(client) && !client.isDeleted}>
            <Tooltip title="View">
              <Visibility />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      edit: checkPermission([message.manage_client]) ? (
        client.isDeleted === false ? (
          <IconButton onClick={() => editClient(client) && !client.isDeleted}>
            <Tooltip title="Edit">
              <Edit />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      resendRegisterLink: checkPermission([message.manage_contact]) ? (
        //contact should not be deleted, should not be registered, and should have either email/mobile
        !client.isDeleted &&
        !client.isPasswordSet &&
        ((client.UserData[0] &&
          client.UserData[0].email &&
          client.UserData[0].email.address) ||
          (client.UserData[0] && client.UserData[0].mobileNumber)) ? (
          <IconButton
            onClick={() =>
              resendRegisterContactLink(client) && !client.isDeleted
            }
          >
            <Tooltip title="Resend register link">
              <ContentPasteGo />
            </Tooltip>
          </IconButton>
        ) : (
          ""
        )
      ) : (
        ""
      ),
      uploadDoc:
        usertype === message.ACCTOWNER ? (
          client.isDeleted === false ? (
            <IconButton
              onClick={() => contactUploadDoc(client) && !client.isDeleted}
            >
              <Tooltip title="Upload Personal Docs">
                <UploadFile />
              </Tooltip>
            </IconButton>
          ) : (
            ""
          )
        ) : (
          ""
        ),
    };

    rows.push(contactData);
  }
  const filteredClients = rows.filter(
    (contact) =>
      (contact.role === "Client" &&
        contact.firstname &&
        contact.firstname.toLowerCase().includes(filterText.toLowerCase())) ||
      (contact.lastname &&
        contact.lastname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <ClientsFilter
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  });

  return (
    <div>
      {showViewModal || showUploadDoc ? (
        <Detail
          contactData={contactData}
          roleForPopup={"Client"}
          tab={showViewModal ? "1" : showUploadDoc ? "2" : "1"}
          parentCallback={() => closeViewModal()}
        />
      ) : (
        <div>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
            <Col xs="4">
              <h4 className="title-med mt-0 pt-1">Clients</h4>
            </Col>
            <Col align="right" className="contact-btn">
              {checkPermission([message.manage_client]) ? (
                <Button
                  variant="primary"
                  className="btn-blue btn-head"
                  onClick={() => {
                    // if (localStorage.getItem("isActive") === "false") {
                    //   toastMessage(
                    //     code.ERROR,
                    //     "Your subscription is not active, Please activate to continue."
                    //   );
                    // } else {
                    //   showAddClientModal();
                    // }
                    showAddClientModal();
                  }}
                >
                  Add Client
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>

          {showLoader ? (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : rows.length === 0 ? (
            <>
              <Col className="col-auto" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto pl-0 d-flex">
                      <Search style={{ marginTop: "7px" }} />
                      <DebounceInput
                        id="search"
                        minLength={0}
                        debounceTimeout={1500}
                        onChange={(e) => Dosearch(e.target.value)}
                        placeholder="Search"
                        value={filterText}
                        autoComplete="off"
                        className="form-control form-control-sm form-control-head"
                      />

                      <Button
                        type="button"
                        onClick={handleClear}
                        variant="primary"
                        className="btn-blue btn-head ml-2"
                        style={{ marginRight: "19px" }}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>

              <div className="no-transaction">
                <div className="no-transaction-inner">
                  <img src={Logo} className="no-transaction-content" alt="" />
                  <h2 className="no-transaction-content">No clients found</h2>
                  <hr />
                  <Button
                    className="text-uppercase btn-orange btn-orange-lg"
                    onClick={() => {
                      // if (localStorage.getItem("isActive") === "false") {
                      //   toastMessage(
                      //     code.ERROR,
                      //     "Your subscription is not active, Please activate to continue."
                      //   );
                      // } else {
                      //   showAddClientModal();
                      // }

                      showAddClientModal();
                    }}
                  >
                    Add Client
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Col className="col-auto" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    {/* <Col className="col-auto pl-0 d-flex trans-listing-head-dropdown">

                </Col> */}
                    <Col className="col-auto pl-0 d-flex">
                      <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                        <InputLabel id="demo-select-small">Limit</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={PageSize}
                          label="Page"
                          onChange={handleChange}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                      <Search style={{ margin: "7px 5px 0px 5px" }} />
                      <DebounceInput
                        id="search"
                        minLength={0}
                        debounceTimeout={1500}
                        onChange={(e) => Dosearch(e.target.value)}
                        placeholder="Search"
                        value={filterText}
                        autoComplete="off"
                        className="form-control form-control-sm form-control-head"
                      />

                      <Button
                        type="button"
                        onClick={handleClear}
                        variant="primary"
                        className="btn-blue btn-head ml-2 mr-2"
                        // style={{ marginRight: "19px" }}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <DataTable
                title="Contacts"
                columns={columns}
                data={rows}
                persistTableHead
              />
            </>
          )}
          {rows.length > 0 && (
            <>
              <div style={{ marginTop: 10 }}>
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </>
          )}
          <Modal
            show={showAddModal}
            onHide={() => closeAddModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med"
            backdrop={false}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Add Client
              </Modal.Title>
            </Modal.Header>
            <AddContact
              roleForPopup={"Client"}
              onClose={() => closeAddModal()}
            />
          </Modal>

          <Modal
            show={showEditModal}
            onHide={() => closeEditModal()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med"
            backdrop={false}
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Edit Client
              </Modal.Title>
            </Modal.Header>
            <EditContact
              contactData={contactData}
              contacts={clients}
              onClose={() => closeEditModal()}
              roleForPopup={"Client"}
              roleIdForPopup={RollId}
            />
          </Modal>
          {/* <Modal
        show={showViewModal}
        onHide={() => closeViewModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med modal-786"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            View Client
          </Modal.Title>
        </Modal.Header>
        <ViewContact
          contactData={contactData}
          onClose={() => closeViewModal()}
          roleForPopup={"Client"}
        />
      </Modal> */}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(mapStateToProps, {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
  editContactAction,
  addContactActionWithPagination,
  GetCountofInProgressTransactions,
  getUserRolesActionNew,
  getBillingPaymentDetails,
  fetchClientsWithPagination,
  deleteClientAction,
  reactivateClientAction,
  resendRegisterContactLinkAction,
})(Clients);
